// extracted by mini-css-extract-plugin
export default {"AuditReport":"styles_AuditReport__Po4uE","titles":"styles_titles__6cJ1u","title":"styles_title__G7HiI"};